import React from "react"
import imageConstants from "utils/imageConstant"
import resume from "assest/abhay-resume.pdf"
import styles from "./about.module.scss"

function About() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.grid}>
          <div className={styles.textContainer}>
            <p className={styles.subtitle}>About Me</p>
            <h2 className={styles.title}>
              Passionate About <span className={styles.gradient}>Building Products</span>
            </h2>
            <p className={styles.description}>
              I'm Abhay Sharma, a Senior Application Developer at ADP currently based in the United States. 
              With over 8 years of professional software engineering experience, I specialize in crafting high-performance, 
              scalable full-stack applications that drive tangible business value (including solutions saving over $6M annually).
            </p>
            <p className={styles.description}>
              Beyond my corporate role at ADP, I am the founder of <strong>ProgressMates</strong>, an enterprise-grade construction ERP and 
              financial analytics SaaS. I love taking products from concept to launch, optimizing complex systems, and building 
              seamless interactive user experiences.
            </p>
            <p className={styles.description}>
              My current technological stack includes React, React Native, Node.js, TypeScript, Express, GraphQL, Redis, MongoDB, 
              and AWS/GCP cloud environments.
            </p>
            <div className={styles.btnContainer}>
              <a href={resume} download className={styles.downloadButton}>
                Download CV <span className={styles.icon}>↓</span>
              </a>
            </div>
          </div>

          <div className={styles.imageWrapper}>
            <div className={styles.imageDecoration} />
            <img
              src={imageConstants.ME_ICON}
              className={styles.profileImage}
              alt="Abhay Sharma profile"
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
